module.exports = __webpack_public_path__ + "static/media/about-us.97518f47.webp";